<template>
    <router-view />
    <!-- <hr />
    SVG内联演示：<Icon name="iruxu" :size="24" />
    <hr />
    多语言演示：{{ $t("common.demo.hello") }}
    <hr />

    <ul>
        <li>当前页面：Index</li>
        <li>当前环境：{{ ENV_NAME }}</li>
    </ul> -->
</template>

<script>
import { mapActions } from "vuex";
import { getTradeCalendar, getTradeCalendarFree } from "./service/common";
import { formatDate } from "./utils";
import dayjs from "dayjs";
import User from "@2kog/pkg-common/utils/user";
export default {
    name: "App",
    components: {},
    props: [],
    data: function () {
        return {
            ENV_NAME: import.meta.env.VITE_ENV_NAME,
        };
    },
    created() {
        this.loadTrade();
    },
    methods: {
        ...mapActions(["setTradingDay", "setTrades"]),
        async loadTrade() {
            // 获取当前月份交易日列表
            const fn = User.isLogin() ? getTradeCalendar : getTradeCalendarFree;
            const res = await fn();
            const trades = res.data.data?.days || [];
            this.setTrades(trades); // 只设置一次当前月数据

            const today = formatDate(dayjs());
            const nowHour = dayjs().hour();
            const yesterday = formatDate(dayjs().subtract(1, "day"));

            const todayIsTrade = trades.some((item) => item.date === today && item.status == "1");
            const yesterdayIsTrade = trades.some((item) => item.date === yesterday && item.status == "1");

            let latestTradingDay = null;

            if (todayIsTrade) {
                // 今天18点前，今天的数据还在采集中，展示昨天的数据
                // 今天18点后，今天的数据已采集完成，展示今天的数据
                if (nowHour < 18) {
                    // 18点前：展示昨天（找昨天或昨天之前的最后一个交易日）
                    if (yesterdayIsTrade) {
                        latestTradingDay = yesterday;
                    } else {
                        // 昨天不是交易日，找昨天之前的最后一个交易日
                        const todayIndex = trades.findIndex((item) => item.date === today);
                        const lastTradeDay = trades
                            .slice(0, todayIndex)
                            .reverse()
                            .find((item) => item.status === "1");
                        latestTradingDay = lastTradeDay?.date || today;
                    }
                } else {
                    latestTradingDay = today;
                }
            } else {
                // 直接查找前面的最后一个交易日
                const tIndex = trades.findIndex((item) => item.date === today);

                // 如果今天不在列表中（tIndex === -1），从列表末尾开始找最近的交易日
                let lastTradeDay;
                if (tIndex === -1) {
                    // 今天不在列表中，说明今天比列表中所有日期都晚
                    // 从后往前找最后一个状态为1的交易日
                    lastTradeDay = trades
                        .slice()
                        .reverse()
                        .find((item) => item.status === "1");
                } else {
                    // 今天在列表中，从今天之前找最后一个交易日
                    lastTradeDay = trades
                        .slice(0, tIndex)
                        .reverse()
                        .find((item) => item.status === "1");
                }

                latestTradingDay = lastTradeDay?.date || null;
            }

            if (latestTradingDay) {
                this.setTradingDay(latestTradingDay);
            } else {
                // 请求上月数据
                const lastMonth = dayjs().subtract(1, "month").format("YYYY-MM");
                const lastRes = await getTradeCalendar(lastMonth);
                const lastTrades = lastRes.data.data?.days || [];

                const lastTradeDay = lastTrades.reverse().find((item) => item.status === "1");
                if (lastTradeDay) {
                    this.setTrades(lastTrades);
                    this.setTradingDay(lastTradeDay.date);
                } else {
                    console.error("未找到有效的交易日");
                }
            }
        },
    },
};
</script>

<style lang="less">
@import "@/assets/css/app.less";
</style>
